import { Link } from 'react-router-dom';
import PublicFooter from '../components/PublicFooter.js';

export default function Landing() {
  return (
    <>
    <div className="mx-auto max-w-3xl px-6 py-24 text-center">
      <p className="mb-3 text-xs font-medium uppercase tracking-[0.18em] text-brand-600">
        adhc.to
      </p>
      <h1 className="text-4xl font-semibold tracking-tight text-slate-900 sm:text-5xl">
        Short links, fast as the edge.
      </h1>
      <p className="mx-auto mt-5 max-w-xl text-base leading-7 text-slate-600">
        Create, share, and measure short links on a Cloudflare-native stack.
        Invite-only while we ramp up.
      </p>
      <div className="mt-8 flex items-center justify-center gap-3">
        <Link to="/login" className="btn-primary px-5 py-2.5 text-base">
          Sign in
        </Link>
        <Link to="/signup" className="btn-secondary px-5 py-2.5 text-base">
          Have an invite code?
        </Link>
      </div>

      <div className="mt-20 grid gap-4 sm:grid-cols-3 text-left">
        {[
          ['Edge redirects', 'KV-cached lookups, async click logging via waitUntil.'],
          ['Custom aliases', 'Reserve adhc.to/yourbrand or auto-generate a base62 slug.'],
          ['Real analytics', 'Country, referrer, browser, device — without slowing the redirect.'],
        ].map(([title, body]) => (
          <div key={title} className="card p-5">
            <p className="text-sm font-semibold text-slate-900">{title}</p>
            <p className="mt-1 text-sm text-slate-600">{body}</p>
          </div>
        ))}
      </div>
    </div>
    <PublicFooter />
    </>
  );
}
